<app-page-loader></app-page-loader>
<router-outlet></router-outlet>
<app-accessibility></app-accessibility>
<!-- Protectie temporara pentru testare -->
<!-- <div class="limiter" *ngIf="!allowAccess">
    <div class="container-login100" style="background: #FFF;">
      <div class="wrap-login100">
          <div class="login100-form w-450 validate-form">
            <div class="form-content">
                <span class="login100-form-title m-b-5">
                    Testare Portal Medical
                </span>
                <span class="login100-form-title subtitle m-b-25">
                    Pentru testare introduceti parola comunicata
                </span>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                        <mat-form-field class="example-full-width" appearance="outline">
                            <mat-label>Parola</mat-label>
                            <input matInput type="password" name="password" #password (keyup.enter)="doAccess()"/>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row" *ngIf="errorMessage">
                    <div class="col-xl-12col-lg-12 col-md-12 col-sm-12 mb-2">
                      <div class="alert alert-danger">{{ errorMessage }}</div>
                    </div>
                  </div>
                <div class="container-login100-form-btn">
                    <button mat-flat-button color="primary" class="login100-form-btn" (click)="doAccess()">Accesati</button>
                  </div>
            </div>
          </div>
    </div>
</div> -->